import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';

import { themes } from '../../themes/';
import { useBrand } from './BrandProvider';
import ResponsiveProvider from './ResponsiveProvider';
import { useVersion } from './VersionProvider';

// BlueStone not having a prefix
const themePrefixes = {
  cobalt: 'COBALT_',
  diamond: 'DIAMOND_',
};

export const ThemeProvider = ({ children }) => {
  const brand = useBrand();
  const version = useVersion();
  const prefix = themePrefixes[version] || '';
  const themeName = `${prefix}${brand}`;
  const theme = themes[themeName];

  return (
    <EmotionThemeProvider theme={theme}>
      <ResponsiveProvider>{children}</ResponsiveProvider>
    </EmotionThemeProvider>
  );
};
